const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  button: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
  loading:{
    marginTop: '20px',
    marginLeft: '20px'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/organisation/styles.js